import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
import { parseResponse, responseTypes } from '@jweb-development/response-parser'
import moment from 'moment'

import {
  SET_INTEGRATION_SETTINGS, GET_DESTINATION_REQUESTS, VALIDATE_SETTINGS, DELETE_CISCO_SETTINGS, ADD_DESTINATION_LIST, GET_DESTINATION_LISTS,
  UPDATE_BLOCK_REQUEST, DELETE_DESTINATION_LIST
} from '../types'

const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

const CISCO_ERRORS = {
  ORGANIZATION_ERROR: 'ORGANIZATION_ERROR',
  BAD_ORGANIZATION_ERROR: 'BAD_ORGANIZATION_ERROR',
  MANAGEMENT_ERROR: 'MANAGEMENT_ERROR',
  NO_ORGANIZATION: 'NO_ORGANIZATION',
  NO_API_KEY: 'NO_API_KEY',
  NO_API_SECRET: 'NO_API_SECRET'
}

const REQUEST_ERRORS = {
  DOMAIN_EXISTS: 'DOMAIN_EXISTS',
  DOMAIN_RESTRCITED: 'DOMAIN_RESTRICTED'
}

// fetches org setup for cisco umbrella
export const getCiscoSettings = async (props) => {
  const { token, accountId } = props
  if (!token || !accountId) { return false }
  // await a sample promise
  const options = {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  }
  const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/integrations/cisco/settings`, options))
  const parsedResponse = parseResponse(response)

  if (parsedResponse && !parsedResponse.error) {
    const data = await response.json()
    return data
  } else {
    log.error(parsedResponse)
    return false
  }
}

export const getDestinationLists = (fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch = () => { }, getState = () => { }) => {
    try {
      const { token, accountId: accountID } = getState().auth

      const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/integrations/cisco/destinationLists`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const { data: { data: destinationLists = [] } = {} } = await response.json()
        dispatch({ type: GET_DESTINATION_LISTS, payload: destinationLists })

        fireSuccess()
      } else {
        fireFailure()
      }
    } catch (err) {
      console.error(err)
    }
  }
}

// soft delete for cisco umbrella settings
export const deleteCiscoSettings = (fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch = () => { }, getState = () => { }) => {
    const { token, accountId } = getState().auth
    // await a sample promise
    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }
    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/integrations/cisco`, options))
    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      dispatch({
        type: DELETE_CISCO_SETTINGS,
        payload: true
      })
      fireSuccess()
    } else {
      log.error(parsedResponse)
      fireFailure()
    }
  }
}

// validates org setup for cisco umbrella
export const validateOrgSetup = (props, resolve = () => { }, reject = () => { }) => {
  return async (dispatch = () => { }, getState = () => { }) => {
    try {
      const { token, accountId: accountID } = getState().auth
      const { summary = null, units = null } = props

      if (!token || !accountID || !summary || !units) { resolve(false); return false }

      if (!summary.organizationID || !summary.organizationID.length) { resolve({ data: null, error: true, code: CISCO_ERRORS.NO_ORGANIZATION }); return false }
      if (!summary.apiKey || !summary.apiKey.length) { resolve({ data: null, error: true, code: CISCO_ERRORS.NO_API_KEY }); return false }
      if (!summary.apiSecret || !summary.apiSecret.length) { resolve({ data: null, error: true, code: CISCO_ERRORS.NO_API_SECRET }); return false }

      // JJC check the secret token; if it seems one has been previously saved then set it to null
      // if (typeof summary.apiSecret === 'string' && summary.apiSecret.includes('*')) {
      //   summary.apiSecret = null
      // }
      const body = { summary, units }
      // await a sample promise
      const options = {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      }
      const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/integrations/cisco/validate`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && parsedResponse.type === responseTypes.SUCCESS) {
        const { data } = await response.json()
        const { data: destinationLists } = data
        dispatch({ type: VALIDATE_SETTINGS, payload: destinationLists })
        resolve(data)
        return data
      } else {
        if (parsedResponse && parsedResponse.type === responseTypes.FORBIDDEN) {
          resolve({ data: null, error: true, code: CISCO_ERRORS.MANAGEMENT_ERROR })
          return false
        }

        if (parsedResponse && parsedResponse.type === responseTypes.NOT_FOUND) {
          resolve({ data: null, error: true, code: CISCO_ERRORS.ORGANIZATION_ERROR })
          return false
        }

        resolve({ data: null, error: true, code: CISCO_ERRORS.BAD_ORGANIZATION_ERROR })
        return false
      }
    } catch (err) {
      console.error(err)
      resolve({ data: null, error: true, code: CISCO_ERRORS.BAD_ORGANIZATION_ERROR })
    }
  }
}

// validates org setup for cisco umbrella
export const updateCiscoOrgSetup = (props, type, fireSuccess, fireFailure) => {
  return async (dispatch, getState) => {
    const { token, accountId } = getState().auth
    const { summary = null, units = null } = props
    if (!summary || !units) { return false }
    // JJC check the secret token; if it seems one has been previously saved then set it to null
    // if (summary && typeof summary.apiSecret === 'string' && summary.apiSecret.includes('*')) {
    //   summary.apiSecret = null
    // }
    const body = {
      summary,
      units
    }
    // await a sample promise
    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }
    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/integrations/cisco/settings`, options))
    const parsedResponse = parseResponse(response)

    if (parsedResponse && !parsedResponse.error) {
      const { data: { settings = {} } = {} } = await response.json()
      dispatch({
        type: SET_INTEGRATION_SETTINGS,
        payload: settings
      })
      fireSuccess()
    } else {
      log.error(parsedResponse)
      fireFailure()
    }
  }
}

// updates settings for a particular integration
export const setIntegrationSettings = (form, type, fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch, getState) => {
    // const { token, accountId } = getState().auth
    // await a sample promise
    await new Promise(resolve => resolve(true))
    console.log(form)
    dispatch({
      type: SET_INTEGRATION_SETTINGS,
      payload: {
        type,
        body: form
      }
    })
    return fireSuccess()
  }
}

export const getDestinationRequests = (fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch = () => { }, getState = () => { }) => {
    try {
      const { accountId: accountID, token } = getState().auth

      const options = {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      }

      const response = await window.fetch(`${api}/accounts/${accountID}/integrations/cisco/settings/destinations`, options)
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const { data } = await response.json()
        dispatch({ type: GET_DESTINATION_REQUESTS, payload: data })
      } else {
        fireFailure()
      }
    } catch (err) {
      console.error(err)
      return false
    }
  }
}

/**
 * Request for new destination list
 * @param {Object} listInfo - Object with new destination list information
 * @param {string} listInfo.name - New name for destination list
 * @param {string} listInfo.units - Units to assign destination list to
 * @param {Array} listInfo.destinations - Array of new destinations to be added to new destination list
 * @param {string} listInfo.destinations[].comment - Comment for new destination to be added
 * @param {string} listInfo.destinations[].destination - Destination to be added
 * @param {*} fireSuccess - success function
 * @param {*} fireFailure - failure function
 * @returns
 */
export const addDestinationList = (listInfo, fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch, getState) => {
    try {
      const {
        token, accountId: accountID, supervisorID, username = '', firstName = '', lastName = ''
      } = getState().auth

      const { destinationLists = [] } = getState().integrations
      const tempDestinationLists = [...destinationLists]

      if (!listInfo || !listInfo.destinations || !listInfo.name || !listInfo.units) { fireFailure(); return false }

      const { destinations, name, units } = listInfo
      const body = {
        isDnsPolicy: true,
        isGlobal: false,
        destinations,
        name,
        supervisorID,
        units
      }

      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/integrations/cisco/destinationLists`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const { data: { destinationList = {} } = {} } = await response.json()
        tempDestinationLists.push({ ...destinationList, emailAddress: username, firstName, lastName, createdBy: supervisorID, mappings: units })

        const newMappings = units.reduce((obj, unitInfo) => {
          if (unitInfo && unitInfo.unitID) {
            obj[unitInfo.unitID] = {
              apiKey: '',
              apiSecret: '',
              createdAt: moment().unix(),
              createdBy: supervisorID,
              destinationListID: destinationList.destinationListID,
              destinationListName: name,
              organizationID: null,
              unitID: unitInfo.unitID
            }
          }
          return obj
        }, {})

        dispatch({ type: ADD_DESTINATION_LIST, payload: { destinationLists: tempDestinationLists, newMappings } })
        fireSuccess()
      } else {
        fireFailure()
      }
    } catch (err) {
      console.error(err)
      fireFailure()
    }
  }
}

export const requestDestination = (requestInfo, fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch = () => { }, getState = () => { }) => {
    try {
      const { token, accountId: accountID, supervisorID } = getState().auth

      const { unitID, destination, comment } = requestInfo
      if (!unitID || !destination || comment == null) { fireFailure(); return false }
      const body = { unitID, destination, comment, supervisorID }

      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/integrations/cisco/settings/destinations`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && parsedResponse.type === responseTypes.SUCCESS) {
        let destinationDomain = ''

        try {
          const { hostname: destinationHostname = '' } = new URL(destination)
          destinationDomain = destinationHostname
        } catch (err) {
          destinationDomain = destination
        }

        dispatch({ type: UPDATE_BLOCK_REQUEST, payload: { accountID, domain: destinationDomain, createdAt: moment().unix() } })

        fireSuccess(); return true
      } else {
        if (parsedResponse && parsedResponse.type === responseTypes.NO_CONTENT) {
          fireFailure(REQUEST_ERRORS.DOMAIN_EXISTS); return false
        }

        if (parsedResponse && parsedResponse.type === responseTypes.FORBIDDEN) {
          fireFailure(REQUEST_ERRORS.DOMAIN_RESTRCITED); return false
        }

        fireFailure(); return false
      }
    } catch (err) {
      console.error(err)
      fireFailure()
    }
  }
}

export const updateDestinationRequests = (destinationsApproved, destinationsDenied, fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch = () => { }, getState = () => { }) => {
    try {
      const { token, accountId: accountID, supervisorID } = getState().auth

      if (!destinationsApproved || !destinationsDenied || !supervisorID) { fireFailure(); return false }
      const body = { destinationsApproved, destinationsDenied, supervisorID }

      const options = {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/integrations/cisco/destinations`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && parsedResponse.type === responseTypes.SUCCESS) {
        fireSuccess()
      } else {
        if (parsedResponse && parsedResponse.type === responseTypes.PARTIAL_SUCCESS) {
          const { data: { rejected = [], accepted = [] } } = await response.json()
          fireSuccess({ rejected, accepted })
        } else {
          fireFailure()
        }
      }
    } catch (err) {
      console.error(err)
      fireFailure()
    }
  }
}

export const deleteDestinationList = (destinationListID, ciscoID, fireSuccess = () => { }, fireFailure = () => { }) => {
  return async (dispatch = () => { }, getState = () => { }) => {
    try {
      const { token, accountId: accountID, supervisorID } = getState().auth

      const { destinationLists = [] } = getState().integrations
      const tempDestinationLists = [...destinationLists]

      if (!destinationListID || !supervisorID || !ciscoID) { return false }

      const options = {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ supervisorID, ciscoID })
      }

      const response = await trackPromise(window.fetch(`${api}/accounts/${accountID}/integrations/cisco/destinationLists/${destinationListID}`, options))
      const parsedResponse = parseResponse(response)

      if (parsedResponse && !parsedResponse.error) {
        const newDestinationLists = tempDestinationLists.filter((listInfo) => listInfo && listInfo.destinationListID !== destinationListID)
        dispatch({ type: DELETE_DESTINATION_LIST, payload: newDestinationLists })
        fireSuccess()
      } else {
        fireFailure()
      }
    } catch (err) {
      console.error(err)
      fireFailure()
    }
  }
}
